"use client";
import {
  dropdown_section_default
} from "./chunk-ALQVDQFM.mjs";
import {
  dropdown_item_default
} from "./chunk-SUBVIRYL.mjs";
import {
  useDropdownContext
} from "./chunk-WRRPXIUB.mjs";

// src/dropdown-menu.tsx
import { PopoverContent } from "@nextui-org/popover";
import { useMenu } from "@react-aria/menu";
import { useDOMRef } from "@nextui-org/react-utils";
import { useTreeState } from "@react-stately/tree";
import { dropdownMenu } from "@nextui-org/theme";
import { FocusScope } from "@react-aria/focus";
import { useMemo } from "react";
import { forwardRef } from "@nextui-org/system";
import { jsx } from "react/jsx-runtime";
var DropdownMenu = forwardRef(
  ({
    as,
    variant,
    color,
    disableAnimation,
    onAction,
    closeOnSelect,
    className,
    itemClasses,
    ...otherProps
  }, ref) => {
    const { getMenuProps } = useDropdownContext();
    const Component = as || "ul";
    const domRef = useDOMRef(ref);
    const state = useTreeState(otherProps);
    const { menuProps } = useMenu(otherProps, state, domRef);
    const classNames = useMemo(() => dropdownMenu({ className }), [className]);
    return /* @__PURE__ */ jsx(PopoverContent, { children: /* @__PURE__ */ jsx(FocusScope, { contain: true, restoreFocus: true, children: /* @__PURE__ */ jsx(Component, { ...getMenuProps({ ...menuProps }, domRef), className: classNames, children: [...state.collection].map((item) => {
      const itemProps = {
        closeOnSelect,
        color,
        disableAnimation,
        item,
        state,
        variant,
        onAction,
        ...item.props
      };
      if (item.type === "section") {
        return /* @__PURE__ */ jsx(dropdown_section_default, { ...itemProps, itemClasses }, item.key);
      }
      let dropdownItem = /* @__PURE__ */ jsx(dropdown_item_default, { ...itemProps, classNames: itemClasses }, item.key);
      if (item.wrapper) {
        dropdownItem = item.wrapper(dropdownItem);
      }
      return dropdownItem;
    }) }) }) });
  }
);
DropdownMenu.displayName = "NextUI.DropdownMenu";
var dropdown_menu_default = DropdownMenu;

export {
  dropdown_menu_default
};
